export const HOME = '/';
export const LOGIN = '/login';
export const LOGIN_SESSION_EXPIRED = '/login?session_expired=true';
export const PROFILE = '/profile';
export const BILLING = '/billing';
export const DEVICES = '/devices';
export const SUPPORT = '/support';
export const DEVICE_ACTIVATION = '/activate';

export const SHOP = 'https://homefi.info/collections/accessories';
